const Marionette = require('backbone.marionette');
const ReactDOM = require('react-dom');

module.exports = Marionette.ItemView.extend({
  template() {
    return '';
  },

  onClose() {
    ReactDOM.unmountComponentAtNode(this.$el[0]);
  },

  onShow() {
    if (typeof this.renderComponent !== 'function') {
      throw new TypeError('To use React in Marionette you must add a renderComponent method to your view.');
    }

    ReactDOM.render(this.renderComponent(), this.$el[0]);
  }
});



// WEBPACK FOOTER //
// ./src/views/react_view.js